import { matchPath } from 'react-router';

export interface ApiError {
  code: API_ERROR_CODES;
  title?: string;
  message: string;
  details: [
    {
      source: string;
      message: string;
    },
  ];
}

export type ApiErrorDescription = Map<
  API_ERROR_CODES,
  {
    title?: string;
    message?: string;
  }
>;

export enum API_ERROR_CODES {
  ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE',
  ERR_NETWORK = 'ERR_NETWORK',
  ACCOUNT_BLOCKED = 'account_blocked',
  USER_LOCKED = 'user_locked',
  ACCOUNT_BLOCKED_VALIDATION = 'account_blocked_validation',
  USER_NOT_ACTIVE = 'user_not_active',
  EMAIL_IS_NOT_RECOGNIZED = 'email_is_not_recognized',
  EMAIL_ALREADY_IN_USE = 'email_already_in_use',
  INCORRECT_CODE = 'incorrect_code',
  INCORRECT_USERNAME_OR_PASSWORD = 'incorrect_username_or_password',
  ACCESS_DENIED = 'access_denied',
  VALIDATION = 'validation',
}

export enum API_ERROR_MESSAGE {
  CONDITION_FAILED = 'Condition failed',
}

export const ACCOUNT_BLOCKED_API_ERRORS = [
  API_ERROR_CODES.ACCOUNT_BLOCKED,
  API_ERROR_CODES.ACCOUNT_BLOCKED_VALIDATION,
  API_ERROR_CODES.USER_NOT_ACTIVE,
  API_ERROR_CODES.USER_LOCKED,
];

export const EXCLUDE_ERROS = [...ACCOUNT_BLOCKED_API_ERRORS];

export const UPLOAD_FILE_API_ENDPOINTS = [
  '/users/ira/import/funding-transfers/upload',
  '/employer/:id/users/ira/import/upload',
];

export const isUploadFileUrl = (url: string) => {
  for (const endpoint of UPLOAD_FILE_API_ENDPOINTS) {
    if (matchPath({ path: endpoint, end: false }, url)) {
      return true;
    }
  }
  return false;
};

export function checkCondition<T>(
  condition: T,
  key?: string | unknown[],
): asserts condition is Exclude<T, null | undefined> {
  if (Boolean(condition)) return;

  if (key) {
    const text = typeof key === 'string' ? key : JSON.stringify(key);
    throw new Error(API_ERROR_MESSAGE.CONDITION_FAILED + ` for ${text}`);
  }
  throw Error(API_ERROR_MESSAGE.CONDITION_FAILED);
}
